import { gql } from '@apollo/client'

const destroyDfmFeedbackMutation = gql`
    mutation destroyDfmFeedbackImDfmSlide($dfmFeedbackId: UUID!) {
        destroyDfmFeedback(dfmFeedbackId: $dfmFeedbackId) {
            id
        }
    }
`

export default destroyDfmFeedbackMutation
